import { generatePath } from '@/services/router/generate-path';

/**
 * Where a conversion row goes.
 *
 * A conversion is a goal, and a goal is edited on its own page, which the
 * embedded Journeys app still serves — so the row links out of this app
 * rather than opening a panel beside the list.
 */
export function goalPath(workspaceId: string, goalId: string): string {
  return generatePath('/workspaces/:workspaceId/journeys/goals/:goalId', { workspaceId, goalId });
}
